import {Auth} from "@/services/Api";
import {i18n} from "@/i18n";

declare const window: any;

export function initMiddlewares(router:any) {
    router.beforeResolve(async (to:any, from:any, next:any) => {
        updatePageTitle(to);

        if(to.meta.guest) {
            return next();
        }

        if(to.meta?.needsAuth) {
            if(!Auth.currentUser()) {
                return next({ name: 'Login' });
            }
        }

        if(to.meta.needsSubscription) {
            const currentUser = Auth.currentUser();

            if(!currentUser) {
                return next({ name: 'Login' });
            }

            if(!currentUser.hasSubscription()) {
                return next({ name: 'Plans' });
            }

            if(!currentUser.subscriptionIsActive()) {
                return next({ name: 'PendingSubscription' });
            }

            if(currentUser?.redirect_page && currentUser.redirect_page !== to.fullPath) {
                return next(currentUser.redirect_page);
            }

            return next();
        }

        if(to.name === 'Login' || to.name === 'Register') {
            const currentUser = Auth.currentUser();

            if(currentUser) {
                return next({ name: 'Dashboard' });
            }
        }

        return next();
    })
}

function updatePageTitle(to:any) {
    if(to.meta.title) {
        let title = i18n.global.t(to.meta.title);

        if(window.appConfig?.dash?.name) {
            title += ' - ' + window.appConfig.dash.name;
        }

        document.title = title;
    } else {
        document.title = window.appConfig?.dash?.name;
    }
}
